export enum UnitLocation {
    PassengerDash,
    DriverDash,
    BehindTacho,
    UnderSeat,
    BehindClocks,
    NearsideRear,
    OffsideRear
}
